import { Text } from "@/components/ui/baseUi/text"
import { createBoxDashboardModel } from "@/modules/boxDashboard/models/boxDashboardModel"
import { CommitedClubBlock } from "@/modules/boxDashboard/modules/CommitedClub/components/commitedClubBlock"
import { DailyScheduleBlock } from "@/modules/boxDashboard/modules/DailySchedule/components/dailyScheduleBlock"
import { FinalRoundMembersBlock } from "@/modules/boxDashboard/modules/FinalRoundMembers/components/finalRoundMembersBlock"
import { InactiveMembersBlock } from "@/modules/boxDashboard/modules/InactiveMembers/components/inactiveMembersBlock"
import { KPIBlock } from "@/modules/boxDashboard/modules/KPI/components/kpiBlock"
import { RookieMembersBlock } from "@/modules/boxDashboard/modules/RookieMembers/components/rookieMembersBlock"
import { TeamTasksBlock } from "@/modules/boxDashboard/modules/TeamTask/components/teamTasksBlock"
import { WeeklyTrialsDropInsBlock } from "@/modules/boxDashboard/modules/TrialsDropIns/components/weeklyTrialsDropInsBlock"
import { GriffesIcon } from "@images/svgIcons/griffes"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { word } from "@modules/core/utils/i18n"
import { cn } from "@modules/lib/utils"

export function BoxDashboardPage({ className, ...props }: { className?: string } & React.ComponentProps<"div">) {
  const { result: box } = useCurrentBox()
  const model = createBoxDashboardModel(box)

  return (
    <div className={cn("relative isolate flex w-full flex-col gap-8 p-6", className)} {...props}>
      <GriffesIcon
        className="pointer-events-none absolute top-0 left-0 z-0 h-auto w-9/10 max-w-250 object-top-left lg:w-8/10 xl:w-7/10"
        color="currentColor"
        aria-hidden="true"
      />

      <div className="z-1 mb-6 flex w-full items-center overflow-hidden rounded-3xl bg-surface-foreground px-4 py-2">
        <Text fontStyle="HM" className="text-textDefault-heading">
          {word("menu.dashboard")}
        </Text>
      </div>

      {/* 1 column layout for tablets */}
      <div className="z-1 mx-auto flex w-full max-w-150 flex-col gap-8 xl:hidden">
        {model.showDailySchedule && <DailyScheduleBlock />}
        {model.showWeeklyTrialsDropIns && <WeeklyTrialsDropInsBlock />}
        {model.showTeamTasks && <TeamTasksBlock />}
        {model.showKPI && <KPIBlock />}
        <CommitedClubBlock />
        {model.showInactiveMembers && <InactiveMembersBlock />}
        <RookieMembersBlock />
        <FinalRoundMembersBlock />
      </div>

      {/* 2 columns layout for xl+ */}
      <div className="z-1 mx-auto hidden w-full max-w-300 justify-center gap-8 xl:flex">
        <div className="flex w-full max-w-150 flex-col gap-8">
          {model.showDailySchedule && <DailyScheduleBlock />}
          {model.showKPI && <KPIBlock />}
          {!model.showKPI && <RookieMembersBlock />}
          {!model.showKPI && <InactiveMembersBlock />}
        </div>
        <div className="flex w-full max-w-150 flex-col gap-8">
          {model.showWeeklyTrialsDropIns && <WeeklyTrialsDropInsBlock />}
          {model.showTeamTasks && <TeamTasksBlock />}
          <CommitedClubBlock />
          {model.showKPI && <RookieMembersBlock />}
          <FinalRoundMembersBlock />
          {model.showKPI && model.showInactiveMembers && <InactiveMembersBlock />}
        </div>
      </div>
    </div>
  )
}
